import { getFileUrl } from './getFileUrl';

export const handleFileEntryDownload = async (file: { downloadToken: string; filename: string; uuid: string }) => {
  const token = file.downloadToken;
  const link = document.createElement('a');
  link.download = file.filename ?? '';
  link.href = getFileUrl(file.uuid, token ?? '');
  link.target = '_blank';
  link.click();
};
